








import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppText } from '@/uikit';

@Component({
  components: {
    AppText,
  },
})
export default class DepartmentElement extends Vue {
  @Prop({ type: Object, default: {} })
  item: {};
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/footer/coordinators/element/CoordinatorElement.vue